export function cleanSelectedElement(selectedEl: HTMLElement | null) {
    if (!selectedEl) return;

    // yeni bir range oluştur
    const range = document.createRange();
    range.selectNodeContents(selectedEl);

    // içeriği klonla
    const fragment = range.cloneContents();

    // seçili elementin yerini sadece içeriğiyle değiştir
    const parent = selectedEl.parentElement;
    if (!parent) return;

    parent.replaceChild(fragment, selectedEl);

    // seçim ve outline temizliği
    selectedEl.style.outline = "";
    selectedEl.style.outlineOffset = "";
}